import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class CsvStationLoader {
  public csvStations: CsvStation[]  = [];

  constructor(){
    fetch(environment.stationCsvUrl, {
      method:'GET'
    })
      .then(req => req.text())
      .then(csv => {
        const tmp = csv.split('\r\n');

        for (let index = 1; index < tmp.length; index++) {
          //カンマ区切りで配列に分割
          const row = tmp[index].split(',');
          const data: CsvStation = {
            code: row[0],
            type: row[1],
            name: row[2],
            yomi: row[3],
            districtL: row[4],
            districtS: row[5],
            lat: Number.parseInt(row[6]),
            lon: Number.parseInt(row[7]),
            address: row[8],
            tel: row[9],
            nickname: row[10],
            nicknameKana: row[11],
            keyword: row[12],
            keywordKana: row[13],
            zone: row[14],
            fareZone: row[15]
          };
          this.csvStations.push(data);
        }
     })
  }
}

/** CSV取得のステーション情報. */
export interface CsvStation {
  code: string;
  type: string;
  name: string;
  yomi:  string;
  districtL: string;
  districtS: string;
  lat: number;
  lon: number;
  address: string;
  tel: string;
  nickname: string;
  nicknameKana: string;
  keyword: string;
  keywordKana: string;
  zone: string;
  fareZone: string;
}



// WEBPACK FOOTER //
// ./src/providers/servicer/csv-station-loader.ts